import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AboutSecTwo = ({ className = '' }) => {
  const { t } = useTranslation();
  const features = t('sections.aboutSecTwo.features', { returnObjects: true }) || [
    'Expert Cybersecurity Consulting',
    'Vulnerability Assessment',
    'Advanced Threat Detection',
    'Incident Response and Recovery',
    'Data Privacy and Compliance',
    'Customized Security Solutions',
  ];

  return (
    <div className={`about-sec2 ${className}`} id="about-sec">
      <div className="shape-mockup bg-gradient-shape1" data-bottom="0" data-right="0" data-left="auto" data-top="auto"></div>
      <div className="container">
        <div className="row gy-40">
          <div className="col-xl-6">
            <div className="img-box2" data-cue="slideInLeft">
              <div className="img1">
                <div className="img-box2-shape1"></div>
                <img src="assets/img/normal/about2-1.png" alt="About" />
              </div>
              <div className="about-experience-wrap jump">
                <div className="box-icon">
                  <img src="assets/img/icon/about-icon2-1.svg" alt="icon" />
                </div>
                <div className="about-counter-wrap">
                  {t('sections.aboutSecTwo.trusted_by', 'Trusted By 5k Clients')}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="about-wrap2">
              <div className="title-area mb-25">
                <span className="sub-title style2" data-cue="slideInUp">{t('sections.aboutSecTwo.sub_title','About Our Company')}</span>
                <h2 className="sec-title" data-cue="slideInUp" data-delay="100">
                  {t('sections.aboutSecTwo.title','Innovation at the Core Driving the Future of Security')}
                </h2>
                <p className="sec-text" data-cue="slideInUp" data-delay="200">
                  {t('sections.aboutSecTwo.text','Secur is a pioneering cybersecurity firm dedicated to safeguarding your digital assets. With over two decades of experience, we\'ve been at the forefront of innovation, providing comprehensive.')}
                </p>
              </div>
              <div className="check-list style-grid" data-cue="slideInUp">
                <ul>
                  {features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i> {feature}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="btn-wrap mt-35" data-cue="slideInUp">
                <Link to="/about" className="ot-btn">
                  {t('sections.aboutSecTwo.more_btn','More About Us')}<i className="far fa-long-arrow-right ms-2"></i>
                </Link>
                <div className="about-profile">
                  <div className="avater">
                    <img src="assets/img/normal/about-profile1-1.png" alt={t('sections.aboutSecTwo.profile.avatar_alt','avatar')} />
                  </div>
                  <div className="media-body">
                    <h5 className="about-profile-name"> {t('sections.aboutSecTwo.profile.name','Andy Dufren')} </h5>
                    <p className="desig">{t('sections.aboutSecTwo.profile.designation','CEO, Founder')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSecTwo;